// 下記ページで使用：レース種目
// /league/qualifying
// /league/qualifying2
// /league/semifinal
// /league/final

import buildDropdown from './modules/dropdown';

export default () => {

  const s = {};
  const init = () => {
    s.root = document.getElementById('migratory');
    if (!s.root) {
      return;
    }

    s.root.isBuilded = false;
    // 下記関数の実行はAPIからのデータ取得、処理後実行
    s.root.buildMigratory = () => {
      s.root.isBuilded = true;
      if (window.matchMedia('(min-width: 768px)').matches) {
        return;
      } else {
        buildDropdown(s.root, '.le-migratory-dropdown');
      }
    }
  }

  init();

  return {}
}
